import axios from '@/utils/axios';
export default {
    namespaced: true,
    state: {
        authorizations: null
    },
    mutations: {
        setAuthorizations(state, payload) {
            state.authorizations = payload;
        }
    },
    actions: {
        fetchAuthorizations({commit, rootState}) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: 'get',
                    url: `${rootState.warehouse.routePrefix}/authorizations`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then((response) => {
                    commit('setAuthorizations', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            })
        }
    }

}